// Limites do odometro e do horimetro, no padrao dos paineis de veiculo: 7 digitos mais uma casa decimal para o
// odometro e 5 digitos mais uma casa para o horimetro. Guardados em metros e milissegundos, como no servidor
// (AccumulatorGuard); as duas pontas precisam mudar juntas.
export const ODOMETER_MAX_METERS = 9999999900;
export const HOURS_MAX_MS = 359999640000;

const ODOMETER_CYCLE_METERS = ODOMETER_MAX_METERS + 100;
const HOURS_CYCLE_MS = HOURS_MAX_MS + 360000;

// Como um painel de veiculo, o contador volta a zero ao passar do maximo. So a exibicao faz isso: o valor guardado
// continua crescendo, porque distancia de viagem, deteccao de movimento e manutencao dependem de ele nao regredir.
export const wrapOdometer = (meters) => meters % ODOMETER_CYCLE_METERS;
export const wrapHours = (ms) => ms % HOURS_CYCLE_MS;
export const odometerRolledOver = (meters) => meters > ODOMETER_MAX_METERS;
export const hoursRolledOver = (ms) => ms > HOURS_MAX_MS;

export const roundOneDecimal = (value) => Math.round(value * 10) / 10;

// Aceita a virgula como separador decimal (pt-BR).
export const parseDecimal = (text) => Number(String(text).trim().replace(',', '.'));

// Quem ve o dispositivo e tem cliente vinculado edita; a conta "Apenas visualizar" nao, e o administrador da
// plataforma, sem cliente, tambem edita. O servidor recusa o resto; aqui so se evita liberar o botao.
export const canEditAccumulators = (user) => !!user && (!!user.administrator || (user.customerId > 0 && !user.readonly));
